import {BaseService} from "@/core/services/BaseService";

class EmailService extends BaseService<any> {
  endpoint = "/email"
}

export default new EmailService()

